<template>
  <nav class="menu-container">
    <h3><font color="#00A2E1">3号线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          name: "fubao",
          title: "福保",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yitian",
          title: "益田",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shixia",
          title: "石厦",
          // icon: "chat",
          exact: true,
        },
        {
          name: "gouwugongyuan",
          title: "购物公园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "futian",
          title: "福田",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shaoniangong",
          title: "少年宫",
          // icon: "chat",
          exact: true,
        },
        {
          name: "lianhuacun",
          title: "莲花村",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huaxin",
          title: "华新",
          // icon: "chat",
          exact: true,
        },
        {
          name: "tongxinling",
          title: "通新岭",
          // icon: "chat",
          exact: true,
        },
        {
          name: "hongling",
          title: "红岭",
          // icon: "chat",
          exact: true,
        },
        {
          name: "laojie",
          title: "老街",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shaibu",
          title: "晒布",
          // icon: "chat",
          exact: true,
        },
        {
          name: "cuizhu",
          title: "翠竹",
          // icon: "chat",
          exact: true,
        },
        {
          name: "tianbei",
          title: "田贝",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shuibei",
          title: "水贝",
          // icon: "chat",
          exact: true,
        },
        {
          name: "caopu",
          title: "草埔",
          // icon: "chat",
          exact: true,
        },
        {
          name: "buji",
          title: "布吉",
          // icon: "chat",
          exact: true,
        },
        {
          name: "mumianwan",
          title: "木棉湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "dafen",
          title: "大芬",
          // icon: "chat",
          exact: true,
        },
        {
          name: "danzhutou",
          title: "丹竹头",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liuyue",
          title: "六约",
          // icon: "chat",
          exact: true,
        },
        {
          name: "tangkeng",
          title: "塘坑",
          // icon: "chat",
          exact: true,
        },
        {
          name: "henggang",
          title: "横岗",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yonghu",
          title: "永湖",
          // icon: "chat",
          exact: true,
        },
        {
          name: "heao",
          title: "荷坳",
          // icon: "chat",
          exact: true,
        },
        {
          name: "dayun",
          title: "大运",
          // icon: "chat",
          exact: true,
        },
        {
          name: "ailian",
          title: "爱联",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jixiang",
          title: "吉祥",
          // icon: "chat",
          exact: true,
        },
        {
          name: "longchengguangchang",
          title: "龙城广场",
          // icon: "chat",
          exact: true,
        },
        {
          name: "nanlian",
          title: "南联",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shuanglong",
          title: "双龙",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>





<!-- <template>
  <div>
    <h3>
        首页<br><br>
深圳地铁1号线 途经站点 共30站<br><br>
注：高峰期发车间隔为4分钟，平峰期为6分钟<br><br>

罗湖站-国贸站-老街站-大剧院站-科学馆站-华强路站-岗厦站-会展中心站-购物公园站-香蜜湖站-车公庙站-竹子林站-侨城东站-华侨城站-世界之窗站-白石洲站-高新园站-深大站-桃园站-大新站-鲤鱼门站-前海湾站-新安站-宝安中心站- 宝体站-坪洲站-西乡站-固戍站-后瑞站-机场东站
    </h3>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style> -->